import { Vector3 } from 'three';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
import { Font, FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';

export const getFontData = (jsonUrl: string): Promise<Font> => {
	const fontLoader = new FontLoader();
	return  new Promise(res => fontLoader.load(jsonUrl, res));
}

export const getBboxScaleByTextGeometry = (geom: TextGeometry) => {
	geom.computeBoundingBox();
	const boundingBox = geom.boundingBox;
	if (!boundingBox) return;
	return boundingBox.getSize(new Vector3());
}

export const getBboxScaleByFont = (text: string, font: Font, size: number, depth: number) => {
	const geom = new TextGeometry(text, { font, size, depth });
	return getBboxScaleByTextGeometry(geom)
}